/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[reminderDataHost]',
    standalone: true,
})
export class ReminderDataDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
